import { render } from "./PatientNavigation.vue?vue&type=template&id=75d52b2b&scoped=true&lang=pug"
import script from "./PatientNavigation.vue?vue&type=script&lang=js"
export * from "./PatientNavigation.vue?vue&type=script&lang=js"

import "./PatientNavigation.vue?vue&type=style&index=0&id=75d52b2b&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75d52b2b"]])

export default __exports__